import { LETTERS } from '~/config/letters'
import { useAppSelector } from '~/store/hooks'

export const useDetailedLabel = () => {
  const products = useAppSelector(state => state.objects.present.products)
  const doors = useAppSelector(state => state.objects.present.doors)
  const doorProductCount = Object.values(doors).filter(d => !!d.product).length
  const productCount = Object.values(products).length + doorProductCount
  const labelLength = Math.floor(productCount / LETTERS.length) + 1
  let detailedLabel = ''
  for (let i = 0; i < labelLength; i++) {
    detailedLabel += LETTERS[productCount % LETTERS.length]
  }
  return detailedLabel
}
